export const TaxExemptStatusEnum = Object.freeze({
  NotDetermined: 0,
  NotExempt: 1,
  Pending: 2,
  Exempt: 3,
  Invalid: 4
})
